import React from 'react';
import { Grid } from '@material-ui/core';
import MonestLoader from 'components/loader/monest-loader';
import './fullscreen-loader.scss';

const FullscreenLoader = ({ text = '', active = false }) => {
    if (!active) {
        return null;
    }
    
    return (
        <div className="FullscreenLoader">
            <Grid container justify="center" alignItems="center" style={{ height: '80%' }}>
                <Grid item xs={12}>
                    <Grid container direction="column" justify="center">
                        <Grid item>
                            <MonestLoader size={3} />
                        </Grid>
                        { text && (
                            <Grid item className="text">
                                { text }
                            </Grid>
                        )}
                    </Grid>
                </Grid>
            </Grid>
        </div>
    );
};

export default FullscreenLoader;